var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarEssaygrader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.178,
    height: 13.571,
    viewBox: "0 0 10.178 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "test",
    d: "M10.351,3.958A1.131,1.131,0,0,1,9.22,2.827V0H5.827A2.831,2.831,0,0,0,3,2.827v7.916a2.831,2.831,0,0,0,2.827,2.827h4.523a2.831,2.831,0,0,0,2.827-2.827V3.958ZM7.925,11.14l-.911.927a1.275,1.275,0,0,1-1.8,0l-.357-.361a.565.565,0,1,1,.811-.788l.348.358a.141.141,0,0,0,.195-.005l.911-.922a.565.565,0,1,1,.8.792Zm.729-2.658V7.916H7.523v.565a.565.565,0,1,1-1.131,0V6.22a1.7,1.7,0,1,1,3.393,0V8.482a.565.565,0,1,1-1.131,0Zm2.262,3.393H9.785a.565.565,0,0,1,0-1.131h1.131a.565.565,0,0,1,0,1.131ZM8.654,6.22v.565H7.523V6.22a.565.565,0,1,1,1.131,0Zm4.354-3.393H10.351V.17a2.809,2.809,0,0,1,1.062.658l.936.938a2.8,2.8,0,0,1,.659,1.062Z",
    transform: "translate(-3)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarEssaygrader);
export default __webpack_public_path__ + "static/media/sidebar-essaygrader.d3e97b10dc0ea4584b1418aedc388d12.svg";
export { ForwardRef as ReactComponent };